function ProductFinderController($http, deviceDetector) {
    var path = window.location.pathname;
    var self = this;

    self.data = [];
    self.productDisabled = true;
    self.budgets = [];

    self.getCategories = function() {
        return $http.get('/product-finder/categories').then(
            function(response) {
                self.categories = response.data;
                $.each(self.categories, function(key) {
                    if (path.includes(key.replace('_', '-'))) {
                        self.category = key;
                        self.categoryChanged();
                    }
                });
                if (self.category) {
                    self.category = self.category.replace('-', '_');
                    self.categoryChanged();
                }
            },
            function() {
                self.error = true;
                self.globalDisabled = true;
            }
        );
    };

    self.isMobile = function() {
        return deviceDetector.isMobile();
    };

    self.getGiftCategories = function() {
        return $http.get('/product-finder/gift/categories').then(
            function(response) {
                self.giftCategories = response.data;
            },
            function() {
                self.error = true;
                self.globalDisabled = true;
            }
        );
    };

    self.categoryChanged = function() {
        self.budget = '';
        self.selectedItem = '';
        self.productDisabled = (self.category == 'None');
        self.searchText = '';
        if (self.category != 'None' && self.category != 'gifts') {
            self.products = self.querySearch(self.category, self.searchText);
        }
    };

    self.searchTextChange = function(category, query) {
        self.products = self.querySearch(category, query);
    };

    self.selectedItemChange = function(item) {
        if (!item) {
            self.budget = '';
            return;
        }

        var data = {
            category: self.category
        };

        data[item.filter_name] = item.value;
        data['refurb'] = item.refurb;

        $http.get('/product-finder/budgets', {
            params: data
        }).then(
            function(response) {
                self.url = Object.keys(response.data)[0];
                return self.budgets = response.data;
            },
            function() {
                self.error = true;
                self.globalDisabled = true;
            }
        );
    };

    self.giftCategoryChanged = function() {
        self.gift = '';
        self.giftDisabled = false;

        if (self.giftCategory.url) {
            self.url = self.giftCategory.url;
            self.giftDisabled = true;
            return;
        }

        $http.get('/product-finder/gift', {
            params: {
                category: self.giftCategory
            }
        }).then(
            function(response) {
                self.url = Object.keys(response.data)[0];
                return self.gifts = response.data;
            },
            function() {
                self.error = true;
                self.globalDisabled = true;
            }
        );
    };

    self.querySearch = function(category, query) {
        var data = {
            category: self.category
        };
        if (query !== null) {
            data['search'] = query;
        }
        return $http.get('/product-finder/product', {
            params: data
        }).then(
            function(response) {
                return $.map(response.data, function(el) {
                    return el;
                });
            },
            function() {
                self.error = true;
                self.globalDisabled = true;
            }
        );
    };
}

ProductFinderController.$inject = ['$http', 'deviceDetector'];

var ProductFinderComponents = angular.module('ProductFinder.components', ['ng.deviceDetector']);

ProductFinderComponents.component('productFinder', {
    templateUrl: 'cdtproductfinder/templates/productFinder.html',
    transclude: true,
    bindings: {
        category: '@'
    },
    controller: ProductFinderController,
    controllerAs: 'ctrl'
});
